module.exports = __webpack_public_path__ + "02_glasses_blue.2750ecdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/02_glasses_blue.png
// module id = gxSF
// module chunks = 0